(() => {
  if (window.countdownTimerModuleInitialized) return;

  window.countdownTimerModuleInitialized = true;

  const instances = new Map();

  class CountdownTimer {
    constructor(element) {
      this.element = element;
      this.section = element.closest('.shopify-section') || element.closest('[data-countdown-section]') || element;
      this.expirationBehavior = element.dataset.expirationBehavior === 'leave' ? 'leave' : 'hide';
      this.expiryText = element.querySelector('[data-countdown-expiry]');
      this.interval = null;
      this.values = {
        days: element.querySelector('[data-days]'),
        hours: element.querySelector('[data-hours]'),
        minutes: element.querySelector('[data-minutes]'),
        seconds: element.querySelector('[data-seconds]'),
      };

      const isoString = element.dataset.expiresAt?.trim();

      if (!isoString) return;

      // Only offset-aware ISO strings are accepted. Liquid adds the shop timezone offset.
      if (!/(?:Z|[+-]\d{2}:\d{2})$/i.test(isoString)) {
        this.element.hidden = true;
        return;
      }

      this.expiresAt = new Date(isoString).getTime();

      if (Number.isNaN(this.expiresAt)) {
        this.element.hidden = true;
        return;
      }

      this.element.hidden = false;
      this.update();

      if (this.expiresAt > Date.now()) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    update() {
      const remainingMilliseconds = this.expiresAt - Date.now();

      if (remainingMilliseconds <= 0) {
        this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        this.expire();
        return;
      }

      const totalSeconds = Math.ceil(remainingMilliseconds / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.render({ days, hours, minutes, seconds });
    }

    render(values) {
      Object.entries(values).forEach(([unit, value]) => {
        if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
      });
    }

    expire() {
      this.stop();

      if (this.expiryText?.dataset.expiredText) {
        this.expiryText.textContent = this.expiryText.dataset.expiredText;
      }

      if (this.expirationBehavior === 'hide') {
        this.section.hidden = true;
      }
    }

    stop() {
      if (this.interval === null) return;

      window.clearInterval(this.interval);
      this.interval = null;
    }

    destroy() {
      this.stop();
      instances.delete(this.element);
    }
  }

  const initialize = (root = document) => {
    const elements = [];

    if (root instanceof Element && root.matches('[data-countdown]')) elements.push(root);
    elements.push(...root.querySelectorAll('[data-countdown]'));

    elements.forEach((element) => {
      if (!instances.has(element)) instances.set(element, new CountdownTimer(element));
    });
  };

  const destroy = (root) => {
    instances.forEach((instance, element) => {
      if (element === root || root.contains(element)) instance.destroy();
    });
  };

  const start = () => {
    initialize();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) initialize(node);
        });
      });

      instances.forEach((instance, element) => {
        if (!element.isConnected) instance.destroy();
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
